'use strict';

var AudioPlayer = require('./AudioPlayer');

module.exports = AudioPlayer.default;


//////////////////
// WEBPACK FOOTER
// ./~/@twilio/audioplayer/es5/index.js
// module id = FIts
// module chunks = 0